import ColorContrastChecker from 'color-contrast-checker';

export const DEFAULT_MIN_CONTRAST_RATIO = 2.5;

export const areColorsLowContrast = (
  background: string | null | undefined,
  foreground: string | Array<string> | undefined,
  ratio: number = DEFAULT_MIN_CONTRAST_RATIO
): boolean => {
  if (!background || !foreground) return false;

  const contrastChecker = new ColorContrastChecker();
  const colors = Array.isArray(foreground) ? foreground : [foreground];

  return colors.some(
    color => !!color && !contrastChecker.isLevelCustom(`#${background}`, `#${color}`, ratio)
  );
};
